var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tablePanel"},[_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.data,"span-method":_vm.handleSpan,"height":850}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }